import { getAccountDetail } from '@repo/accounts-services'
import { defineSagaForService, DownloadServiceConfiguration } from '@repo/core'
import { accountDetailDataActions, accountDetailDownloadActions } from '../../../../slices'

export const accountDetailDataConfig = defineSagaForService({
  [accountDetailDataActions.getRequest.type]: {
    apiClientDomain: 'accounts',
    service: getAccountDetail,
    actionTypeResponse: accountDetailDataActions.getResponse.type,
    actionTypeRequest: accountDetailDataActions.getRequest.type,
    getParams: (params: any) => params,
  },
})

export const accountDetailDownloadConfig: Record<string, DownloadServiceConfiguration> = {
  [accountDetailDownloadActions.downloadRequest.type]: {
    apiClientDomain: 'accounts',
    service: getAccountDetail as DownloadServiceConfiguration['service'],
    actionTypeRequest: accountDetailDownloadActions.downloadRequest.type,
    actionTypeResponse: accountDetailDownloadActions.downloadResponse.type,
  },
}
